import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import '@missionlabs/smartagent-chat-components-lib/dist/index.css';
import '../node_modules/@missionlabs/smartagent-app-components/dist/index.css';
import App from './App';

import 'amazon-connect-streams'
import 'amazon-connect-taskjs';
import 'amazon-connect-chatjs';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

(async () => {
    if ('serviceWorker' in navigator) {
        addEventListener('load', async () => {
            const sw = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`);
            console.log('ONLOAD SERVICE WORKER', sw);
        });
    }
})()